// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__d-wRy","checkmark":"CheckBox_checkmark__CAUKT","lightTheme":"CheckBox_lightTheme__s2f1+"};